type SchemaType = 'request' | 'response';

export type ParseZodSchemaQueryInfo = {
  method?: string;
  endpointName: string;
  url: string;
  schemaType: SchemaType;
};
